/**
 * Shared idempotency-key minting for the admin money POSTs (#251 nit —
 * this was copy-pasted in four places: Bookings settle-now,
 * CardOnFilePayment, ManualCardEntry, StripeTerminalPayment).
 *
 * Contract (#251): ONE stable key per LOGICAL attempt — minted when the
 * attempt begins (dialog opens / component mounts), reused for every
 * deliberate staff retry within that attempt, NEVER re-minted per click.
 * Money POSTs are never transport-retried (adminPaymentsApi money verbs
 * use maxRetries: 0); the server's (tenant_id, idempotency_key) unique +
 * pending-stub machinery absorbs deliberate retries.
 */
export function makeIdempotencyKey(prefix: string, bookingId: string): string {
  const rand = Math.random().toString(36).slice(2, 10);
  return `${prefix}-${bookingId}-${Date.now()}-${rand}`;
}
